import React, { useState } from 'react';
import svgPaths from "./svg-5xl5s73rp3";

// Placeholder image - you can replace this with an actual image URL
const imgContainer = "https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80";

// Hook to simulate responsive breakpoints
function useActiveBreakpoint() {
  const [width, setWidth] = useState(window.innerWidth);
  
  React.useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  return { width };
}

function LabelDesktop() {
  return (
    <div className="h-[20px] relative shrink-0 w-full" data-name="Label">
      <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[20px] left-0 not-italic text-[#364153] text-[14px] text-nowrap top-0 tracking-[-0.1504px] whitespace-pre">Name *</p>
    </div>
  );
}

function TextInputDesktop() {
  return (
    <div className="h-[38px] relative rounded-[6.8px] shrink-0 w-full" data-name="Text Input">
      <input 
        type="text" 
        className="absolute inset-0 border border-gray-300 rounded-[6.8px] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        placeholder="Enter your name"
      />
    </div>
  );
}

function ContainerDesktop() {
  return (
    <div className="[grid-area:1_/_1] content-stretch flex flex-col gap-[4px] items-start relative shrink-0" data-name="Container">
      <LabelDesktop />
      <TextInputDesktop />
    </div>
  );
}

function LabelDesktop1() {
  return (
    <div className="h-[20px] relative shrink-0 w-full" data-name="Label">
      <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[20px] left-0 not-italic text-[#364153] text-[14px] text-nowrap top-0 tracking-[-0.1504px] whitespace-pre">Email *</p>
    </div>
  );
}

function EmailInputDesktop() {
  return (
    <div className="h-[38px] relative rounded-[6.8px] shrink-0 w-full" data-name="Email Input">
      <input 
        type="email" 
        className="absolute inset-0 border border-gray-300 rounded-[6.8px] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        placeholder="Enter your email"
      />
    </div>
  );
}

function ContainerDesktop1() {
  return (
    <div className="[grid-area:1_/_2] content-stretch flex flex-col gap-[4px] items-start relative shrink-0" data-name="Container">
      <LabelDesktop1 />
      <EmailInputDesktop />
    </div>
  );
}

function ContainerDesktop2() {
  return (
    <div className="absolute gap-[16px] grid grid-cols-[repeat(2,_minmax(0px,_1fr))] grid-rows-[repeat(1,_minmax(0px,_1fr))] h-[62px] left-0 right-[-6px] top-0" data-name="Container">
      <ContainerDesktop />
      <ContainerDesktop1 />
    </div>
  );
}

function LabelDesktop2() {
  return (
    <div className="h-[20px] relative shrink-0 w-full" data-name="Label">
      <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[20px] left-0 not-italic text-[#364153] text-[14px] text-nowrap top-0 tracking-[-0.1504px] whitespace-pre">Phone Number</p>
    </div>
  );
}

function PhoneInputDesktop() {
  return (
    <div className="h-[38px] relative rounded-[6.8px] shrink-0 w-full" data-name="Phone Input">
      <input 
        type="tel" 
        className="absolute inset-0 border border-[#d1d5dc] rounded-[6.8px] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        placeholder="Enter your phone number"
      />
    </div>
  );
}

function ContainerDesktop3() {
  return (
    <div className="[grid-area:1_/_1] content-stretch flex flex-col gap-[4px] items-start relative shrink-0" data-name="Container">
      <LabelDesktop2 />
      <PhoneInputDesktop />
    </div>
  );
}

function LabelDesktop3() {
  return (
    <div className="h-[20px] relative shrink-0 w-full" data-name="Label">
      <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[20px] left-0 not-italic text-[#364153] text-[14px] text-nowrap top-0 tracking-[-0.1504px] whitespace-pre">Preferred Date</p>
    </div>
  );
}

function DatePickerDesktop() {
  return (
    <div className="h-[38px] relative rounded-[6.8px] shrink-0 w-full" data-name="Date Picker">
      <input 
        type="date" 
        className="absolute inset-0 border border-[#d1d5dc] rounded-[6.8px] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
      />
    </div>
  );
}

function ContainerDesktop4() {
  return (
    <div className="[grid-area:1_/_2] content-stretch flex flex-col gap-[4px] items-start relative shrink-0" data-name="Container">
      <LabelDesktop3 />
      <DatePickerDesktop />
    </div>
  );
}

function ContainerDesktop5() {
  return (
    <div className="absolute gap-[16px] grid grid-cols-[repeat(2,_minmax(0px,_1fr))] grid-rows-[repeat(1,_minmax(0px,_1fr))] h-[62px] left-0 right-[-6px] top-[78px]" data-name="Container">
      <ContainerDesktop3 />
      <ContainerDesktop4 />
    </div>
  );
}

function LabelDesktop4() {
  return (
    <div className="h-[20px] relative shrink-0 w-full" data-name="Label">
      <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[20px] left-0 not-italic text-[#364153] text-[14px] text-nowrap top-0 tracking-[-0.1504px] whitespace-pre">Preferred Time</p>
    </div>
  );
}

function DropdownDesktop() {
  return (
    <div className="h-[37px] relative rounded-[6.8px] shrink-0 w-full" data-name="Dropdown">
      <select className="absolute inset-0 border border-[#d1d5dc] rounded-[6.8px] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white">
        <option value="">Select a time</option>
        <option value="09:00">9:00 AM</option>
        <option value="10:00">10:00 AM</option>
        <option value="11:00">11:00 AM</option>
        <option value="14:00">2:00 PM</option>
        <option value="15:00">3:00 PM</option>
        <option value="16:00">4:00 PM</option>
      </select>
    </div>
  );
}

function ContainerDesktop6() {
  return (
    <div className="absolute content-stretch flex flex-col gap-[4px] h-[61px] items-start left-0 right-[-6px] top-[156px]" data-name="Container">
      <LabelDesktop4 />
      <DropdownDesktop />
    </div>
  );
}

function LabelDesktop5() {
  return (
    <div className="h-[20px] relative shrink-0 w-full" data-name="Label">
      <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[20px] left-0 not-italic text-[#364153] text-[14px] text-nowrap top-0 tracking-[-0.1504px] whitespace-pre">Your Message *</p>
    </div>
  );
}

function TextAreaDesktop() {
  return (
    <div className="h-[98px] relative rounded-[6.8px] shrink-0 w-full" data-name="Text Area">
      <textarea 
        className="absolute inset-0 border border-gray-300 rounded-[6.8px] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
        placeholder="Enter your message"
        rows={4}
      />
    </div>
  );
}

function ContainerDesktop7() {
  return (
    <div className="absolute content-stretch flex flex-col gap-[4px] h-[128px] items-start left-0 right-[-6px] top-[233px]" data-name="Container">
      <LabelDesktop5 />
      <TextAreaDesktop />
    </div>
  );
}

function IconDesktop() {
  return (
    <div className="absolute left-[85.61px] size-[20px] top-[15px]" data-name="Icon">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 20 20">
        <g id="Icon">
          <path d="M4.16667 10H15.8333" id="Vector" stroke="var(--stroke-0, white)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.66667" />
          <path d={svgPaths.p1ae0b780} id="Vector_2" stroke="var(--stroke-0, white)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.66667" />
        </g>
      </svg>
    </div>
  );
}

function ButtonDesktop() {
  return (
    <button className="absolute bg-[#0070c0] h-[50px] left-0 rounded-[6.8px] top-[381px] w-[130.609px] hover:bg-[#005a9e] transition-colors" data-name="Button">
      <div aria-hidden="true" className="absolute border border-[rgba(0,0,0,0)] border-solid inset-0 pointer-events-none rounded-[6.8px] shadow-[0px_1px_3px_0px_rgba(0,0,0,0.1),0px_1px_2px_-1px_rgba(0,0,0,0.1)]" />
      <p className="absolute font-['Inter:Medium',sans-serif] font-medium leading-[24px] left-[25px] not-italic text-[16px] text-nowrap text-white top-[13px] tracking-[-0.3125px] whitespace-pre">Submit</p>
      <IconDesktop />
    </button>
  );
}

function FormDesktop() {
  return (
    <form className="h-[431px] relative shrink-0 w-full" data-name="Form">
      {/* Contact Us Header */}
      <div className="absolute left-0 right-0 top-[-40px]">
        <h2 className="text-2xl font-bold text-gray-900">Contact Us</h2>
      </div>
      <ContainerDesktop2 />
      <ContainerDesktop5 />
      <ContainerDesktop6 />
      <ContainerDesktop7 />
      <ButtonDesktop />
    </form>
  );
}

function ContainerDesktop8() {
  return (
    <div className="absolute bg-slate-50 bottom-[-20px] box-border content-stretch flex flex-col items-start left-[6px] pb-0 pt-[24px] px-[24px] rounded-[10px] shadow-[0px_4px_6px_-1px_rgba(0,0,0,0.1),0px_2px_4px_-2px_rgba(0,0,0,0.1)] top-[13px] w-[599px]" data-name="Container">
      <FormDesktop />
    </div>
  );
}

function ImageWithFallbackDesktop() {
  // Google Maps embedded iframe for Davenport House, 16 Pepper Street, Canary Wharf, London E14 9RP
  return (
    <iframe
      title="HealthCity Location"
      className="w-full h-full border-0"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2482.9674827896677!2d-0.023442!3d51.504872!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487602b7c2c7c2c3%3A0x2c7a6f3b1c7c7c7c!2sDavenport%20House%2C%2016%20Pepper%20St%2C%20London%20E14%209RP%2C%20UK!5e0!3m2!1sen!2sus!4v1234567890123!5m2!1sen!2sus"
      allowFullScreen
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    />
  );
}

function Heading3Desktop() {
  return (
    <div className="h-[28px] relative shrink-0 w-full" data-name="Heading 3">
      <p className="absolute font-['Inter:Bold',sans-serif] font-bold leading-[28px] left-0 not-italic text-[20px] text-nowrap text-white top-0 tracking-[-0.4492px] whitespace-pre">HealthCity UK</p>
    </div>
  );
}

function ParagraphDesktop() {
  return (
    <div className="h-[20px] relative shrink-0 w-full" data-name="Paragraph">
      <p className="absolute font-['Inter:Regular',sans-serif] font-normal leading-[20px] left-0 not-italic text-[14px] text-[rgba(255,255,255,0.9)] text-nowrap top-0 tracking-[-0.1504px] whitespace-pre">{`We're dedicated to providing the highest quality healthcare services.`}</p>
    </div>
  );
}

function ContainerDesktop9() {
  return (
    <div className="h-[104px] relative shrink-0 w-full" data-name="Container">
      <div className="size-full">
        <div className="box-border content-stretch flex flex-col gap-[8px] h-[104px] items-start pb-0 pt-[24px] px-[24px] relative w-full">
          <Heading3Desktop />
          <ParagraphDesktop />
        </div>
      </div>
    </div>
  );
}

function ContainerDesktop10() {
  return (
    <div className="bg-gradient-to-t box-border content-stretch flex flex-col from-[rgba(0,0,0,0.6)] absolute bottom-0 left-0 right-0 items-start pb-0 pl-0 pr-[217.359px] pt-[24px] to-[rgba(0,0,0,0)]" data-name="Container">
      <ContainerDesktop9 />
    </div>
  );
}

function ContainerDesktop11() {
  return (
    <div className="bg-[rgba(255,255,255,0)] relative overflow-clip rounded-[10px] shadow-[0px_4px_6px_-1px_rgba(0,0,0,0.1),0px_2px_4px_-2px_rgba(0,0,0,0.1)] h-full w-full" data-name="Container">
      <ImageWithFallbackDesktop />
      <ContainerDesktop10 />
    </div>
  );
}

function ContainerDesktop12() {
  return (
    <div className="h-[582px] relative shrink-0 w-[1033px]" data-name="Container">
      <ContainerDesktop8 />
      <ContainerDesktop11 />
    </div>
  );
}

// Operating Hours and Contact Info sections would continue here...
// For brevity, I'll create a simplified version that includes the key elements

// Location Section Component (Bottom Left)
function LocationSection() {
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
        <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
          <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
        </div>
        Office Location
      </h3>
      <div className="text-gray-700 space-y-3">
        <div>
          <p className="font-medium">Healthcity</p>
          <p>Davenport House, 16 Pepper Street</p>
          <p>Canary Wharf, London E14 9RP</p>
          <p>United Kingdom</p>
        </div>
        
        <div className="space-y-2 pt-2 border-t border-gray-200">
          <div className="flex items-center gap-3">
            <svg className="w-5 h-5 text-blue-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            <div>
              <p className="text-sm text-gray-600">Tel No1:</p>
              <a href="tel:03338003006" className="text-blue-600 hover:underline font-medium">0333 800 3006</a>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <svg className="w-5 h-5 text-blue-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            <div>
              <p className="text-sm text-gray-600">Tel No2:</p>
              <a href="tel:03337890012" className="text-blue-600 hover:underline font-medium">0333 789 0012</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Hours Section Component (Bottom Right)
function HoursSection() {
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
        <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
          <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        Operating Hours
      </h3>
      <div className="text-gray-700 space-y-3">
        <div className="flex items-start gap-3">
          <svg className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          <div>
            <p className="font-medium text-gray-900">Services operate Monday to Saturday</p>
          </div>
        </div>
        
        <div className="flex items-start gap-3">
          <svg className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
          </svg>
          <div>
            <p className="font-medium text-gray-900">Canary Wharf Reception Service</p>
            <p className="text-sm text-gray-600">Opens to visitors 9 am to 5.30pm</p>
          </div>
        </div>
        
        <div className="flex items-start gap-3">
          <svg className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
          </svg>
          <div>
            <p className="font-medium text-gray-900">Phone calls</p>
            <p className="text-sm text-gray-600">8.30am to 9 pm</p>
          </div>
        </div>
        
        <div className="flex items-start gap-3">
          <svg className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
          </svg>
          <div>
            <p className="font-medium text-gray-900">Pre-booked services delivered 24 hours</p>
            <p className="text-sm text-gray-600">Face to face, Skype, live chat, telephone, or Online</p>
          </div>
        </div>
      </div>
    </div>
  );
}
function Container() {
  const { width } = useActiveBreakpoint();
  
  if (width < 800) {
    // Mobile layout
    return (
      <div className="min-h-screen bg-gray-50 p-4">
        <div className="max-w-md mx-auto space-y-6">
          <div className="bg-slate-50 rounded-lg shadow-md p-6 pt-16">
            <FormDesktop />
          </div>
          <div className="bg-white rounded-lg shadow-md overflow-hidden relative h-96">
            <ImageWithFallbackDesktop />
            <ContainerDesktop10 />
          </div>
          {/* Operating Hours and Office Location Cards */}
          <LocationSection />
          <HoursSection />
        </div>
      </div>
    );
  }
  
  if (width < 1200) {
    // Tablet layout
    return (
      <div className="min-h-screen bg-gray-50 p-8">
        <div className="max-w-4xl mx-auto space-y-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="bg-slate-50 rounded-lg shadow-md p-6 pt-16">
              <FormDesktop />
            </div>
            <div className="bg-white rounded-lg shadow-md overflow-hidden relative min-h-[600px]">
              <ImageWithFallbackDesktop />
              <ContainerDesktop10 />
            </div>
          </div>
          {/* Operating Hours and Office Location Cards */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <LocationSection />
            <HoursSection />
          </div>
        </div>
      </div>
    );
  }
  
  // Desktop layout
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto p-8 space-y-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="bg-slate-50 rounded-lg shadow-md p-6 pt-16">
            <FormDesktop />
          </div>
          <div className="bg-white rounded-lg shadow-md overflow-hidden relative min-h-[600px]">
            <ImageWithFallbackDesktop />
            <ContainerDesktop10 />
          </div>
        </div>
        {/* Operating Hours and Office Location Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <LocationSection />
          <HoursSection />
        </div>
      </div>
    </div>
  );
}

export default Container;